/**
 * Extracts a human-readable error message from an Angular HttpErrorResponse.
 *
 * Handles the structured 402 upgrade_required response from the API:
 *   { detail: { error: "upgrade_required", limit_type: "pages"|"context", message: "..." } }
 *
 * For all other errors falls back to detail string → message → fallback.
 */
export function extractApiError(err: any, fallback = 'An error occurred'): string {
  if (err?.status === 402) {
    const detail = err?.error?.detail;
    if (detail && typeof detail === 'object' && detail.error === 'upgrade_required') {
      return detail.message || 'Document exceeds the evaluation limit. Add credits to your account.';
    }
  }
  const detail = err?.error?.detail;
  if (detail && typeof detail === 'string') { return detail; }
  return err?.message || fallback;
}

/** Returns true when the error is a structured upgrade_required 402. */
export function isUpgradeRequired(err: any): boolean {
  return err?.status === 402 && err?.error?.detail?.error === 'upgrade_required';
}
